export const TableStates = {
    TABLE_COLUMN_VISIBILITY: 'TABLE_COLUMN_VISIBILITY',
    TABLE_COLUMN_POSITION: 'TABLE_COLUMN_POSITION', // Фиксированная/свободная
    TABLE_CURRENT_PAGE: 'TABLE_CURRENT_PAGE',
    TABLE_PAGE_SIZE: 'TABLE_PAGE_SIZE',
    TABLE_FILTERS: 'TABLE_FILTERS',
    TABLE_EMPTY_FILTERS: 'TABLE_EMPTY_FILTERS',
    TABLE_SEARCH: 'TABLE_SEARCH',
    TABLE_EMPTY_SEARCH: 'TABLE_EMPTY_SEARCH',
};

export const TableActions = {
    TABLE_CHANGE_COLUMN_VISIBILITY: 'TABLE_CHANGE_COLUMN_VISIBILITY',
    TABLE_CHANGE_COLUMN_POSITION: 'TABLE_CHANGE_COLUMN_POSITION',
    TABLE_SET_CURRENT_PAGE: 'TABLE_SET_CURRENT_PAGE',
    TABLE_CHANGE_PAGE_SIZE: 'TABLE_CHANGE_PAGE_SIZE',
    TABLE_CHANGE_FILTERS: 'TABLE_CHANGE_FILTERS',
    TABLE_RESET_FILTERS: 'TABLE_RESET_FILTERS',
    TABLE_CHANGE_SEARCH: 'TABLE_CHANGE_SEARCH',
    TABLE_RESET_SEARCH: 'TABLE_RESET_SEARCH'
};
